import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import _isObjectLike from 'lodash/isObjectLike'
import Vue from 'vue'

let bugsnagClient

if (window.bugsnagKey) {
  const version = document.head.getAttribute('data-version')
  bugsnagClient = Bugsnag.start({
    apiKey: window.bugsnagKey,
    plugins: [new BugsnagPluginVue()],
    appVersion: version || null
  })
  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)
}

const bugsnagNotify = e => {
  if (bugsnagClient) {
    bugsnagClient.notify(!(e instanceof Error) && _isObjectLike(e) ? JSON.stringify(e) : e)
  } else {
    console.error('Busnag not loaded, Exception:', e)
  }
}

export { bugsnagNotify }
